import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { AddressClientFormComponent } from './address-client-form/address-client-form.component'
import { generateHexId } from '../../../shared/utils/utils'

@Component({
  selector: 'address-patient-create',
  standalone: true,
  imports: [AddressClientFormComponent],
  templateUrl: './address-client-create.component.html',
  styleUrl: './address-client-create.component.scss',
})
export class AddressClientCreateComponent implements OnInit {
  constructor() {}

  // apenas 1 endereço
  item: any = {}

  @Output() response: EventEmitter<any> = new EventEmitter()

  ngOnInit(): void {}

  responseForm(element: any) {
    switch (element.action) {
      case 'create':
        this.item = { ...element.item, idCreate: this.generateId() }
        this.response.emit(this.item)
        return
      case 'edit':
        this.item = element.item
        this.response.emit(this.item)
        return
      case 'delete':
        this.item = {}
        this.response.emit(this.item)
        return
      case 'cancel':
        this.item = {}
        return
    }
  }

  generateId() {
    return generateHexId()
  }
}
